import classNames from 'classnames';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { WebSubscriptionPlanConfigType } from '@/modules/subscriptions';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import {
  SubscriptionFullPaymentInfoStyles,
  SubscriptionPerDayPaymentInfoStyles,
} from './SimpleSubscriptionData.styles';

export const SimpleSubscriptionData: React.FC<{
  plan: WebSubscriptionPlanConfigType;
  soldOut?: boolean;
  renderDiscount?: boolean;
  subscription: StripeV2SubscriptionPrice;
}> = ({ plan, soldOut, subscription }) => {
  const isYearlyPlan = subscription.id === 'pro.1y';
  const isMonthlyPlan =
    subscription.id === 'pro.1m' ||
    subscription.id === 'pro.rebill_1m_discount' ||
    subscription.id === 'pro.rebill_month_29_99' ||
    subscription.id === 'pro.rebill_month_49_99' ||
    subscription.id === 'pro.rebill_2weeks_39_99';
  const isThreeMonthPlan =
    subscription.id === 'pro.3m' ||
    subscription.id === 'pro.rebill_3m_discount' ||
    subscription.id === 'pro.rebill_3months_59_99';

  const monthlyPrice = isYearlyPlan
    ? (Math.floor((plan.basePrice / 12) * 100) / 100).toFixed(2)
    : plan.basePrice;

  return (
    <>
      <SubscriptionFullPaymentInfoStyles
        className={classNames({
          soldOut,
        })}
      >
        <div className="plan-duration-left">
          {isMonthlyPlan && (
            <UiTypography variant="title-small">1 month</UiTypography>
          )}

          {isThreeMonthPlan && (
            <UiTypography variant="title-small">3 months</UiTypography>
          )}

          {isYearlyPlan && (
            <>
              <UiTypography variant="title-small">12 months</UiTypography>
              <UiTypography variant="label-small" color="neutral-white">
                Billed annually
              </UiTypography>
            </>
          )}
        </div>
      </SubscriptionFullPaymentInfoStyles>

      <SubscriptionPerDayPaymentInfoStyles
        className={classNames({
          soldOut,
        })}
      >
        <div className="plan-price-right">
          {isMonthlyPlan && (
            <UiTypography variant="title-small">${plan.basePrice}</UiTypography>
          )}

          {isThreeMonthPlan && (
            <UiTypography variant="title-small">${plan.basePrice}</UiTypography>
          )}

          {isYearlyPlan && (
            <>
              <UiTypography variant="title-small">${monthlyPrice}</UiTypography>
              <UiTypography variant="label-small" color="neutral-white">
                per month
              </UiTypography>
            </>
          )}
        </div>
      </SubscriptionPerDayPaymentInfoStyles>
    </>
  );
};
